module.exports = __webpack_public_path__ + "images/128_1024.jpg";